export default class TypePeriodicityInsurance {
  id!: number
  period_type!: string
  isEdit!: boolean
}
